import { isVkPlay } from '@vkplay/shared';

export default {
  name: 'ContactsPage',
  page() {
    return {
      title: this.$i18n.t('contacts.title'),
    };
  },
  computed: {
    contactsCard() {
      return [{
        id: 'partners',
        title: this.$i18n.t('contacts.cards.partners.title'),
        text: this.$i18n.t('contacts.cards.partners.text'),
        email: window.atob(isVkPlay ? 'Yml6ZGV2dmtwbGF5QHZrLnRlYW0=' : 'Yml6ZGV2QG15LmdhbWVz'),
      }, {
        id: 'media',
        title: this.$i18n.t('contacts.cards.media.title'),
        text: this.$i18n.t('contacts.cards.media.text'),
        email: window.atob(isVkPlay ? 'cHJ2a3BsYXlAdmsudGVhbQ==' : 'cHJAbXkuZ2FtZXM='),
      }, {
        id: 'integrations',
        title: this.$i18n.t('contacts.cards.integrations.title'),
        text: this.$i18n.t('contacts.cards.integrations.text', { project: isVkPlay ? 'VK Play' : 'MY.GAMES Store' }),
        email: window.atob(isVkPlay ? 'aW50ZWdyYXRpb25AdmsudGVhbQ==' : 'aW50ZWdyYXRpb25AbXkuZ2FtZXM='),
      }, {
        id: 'support',
        title: this.$i18n.t('contacts.cards.support.title'),
        text: this.$i18n.t('contacts.cards.support.text', { project: isVkPlay ? 'VK Play' : 'MY.GAMES' }),
        supportLink: isVkPlay ? 'https://support.vkplay.ru' : 'https://support.my.games'
      }];
    },
  },
};
